import ExpandedView from "src/components/ExpandedView";
import PatientInvoices from "src/components/PatientInvoices";
import { usePatient } from "src/context/PatientProvider";

const Invoices = () => {
  const patient = usePatient((p) => p);

  return (
    <ExpandedView>
      <PatientInvoices patient={patient} />
    </ExpandedView>
  );
};

export default Invoices;
